/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-05 12:08:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-12 18:26:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/ProductSet/tools/submitData.ts
 */
export const settleData = (state) => {
  const {
    uuid,
    status,
    productInfo,
    tags: outerTags,
    // stock,
    priceSettings,
    advancedPriceSettings,
    dimensions,
    customsInformationItems,
    productStorage = {},
    productType,
    thumbnailImage,
    //inventoryStock,
    defaultCurrency,
    dataValid,
    storeUuid,
    productSetItems,
    // salesChannelAvailableQuantity = [],
    // salesChannelAvailablePresaleQuantity = [],
  } = state;
  // const salesChannelQuotas = salesChannelAvailableQuantity.map((i) => {
  //   const { name, uuid, type, quantity } = i || {};
  //   const { quantity: presaleQuantity } =
  //     salesChannelAvailablePresaleQuantity.find((item) => {
  //       return item.uuid === uuid;
  //     }) || {};

  //   return {
  //     presaleQuantity,
  //     name,
  //     salesChannelUuid: uuid,
  //     channelType: type,
  //     availableQuantity: quantity,
  //   };
  // });
  const {
    sku,
    name,
    measurementUnit: infoMeasurementUnit,
    remarks,
    codes,
    description,
    brand,
    barcode,
    dangerousGoodsClasses,
  } = productInfo;
  const { tags } = outerTags;
  //const { quotaEnabled, inventoryQuota, stockQuantity, stockAvailable } = stock;
  const { defaultSalePrice, taxRule, cost, defaultRrp, localPrices } =
    priceSettings;
  return {
    dangerousGoodsClasses,
    uuid,
    sku,
    name,
    measurementUnit: infoMeasurementUnit,
    remarks,
    thumbnailImage,
    productType,
    // stock: inventoryStock,
    defaultSalePrice,
    defaultRrp,
    localPrices,
    defaultCurrency,
    tags,
    status,
    brand,
    barcode,
    description,
    codes,
    productSetPriceSettings: advancedPriceSettings,
    dimensions,
    // quotaEnabled,
    // inventoryQuota,
    taxRule,
    cost,
    customsInformation: {
      items: customsInformationItems,
    },
    productStorage,
    dataValid,
    storeUuid,
    productSet: { items: productSetItems },
    //stockQuantity,
    // stockAvailable,
    //salesChannelQuotas,
  };
};
